import React, { useState, useContext, useEffect } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import StoreIcon from "@mui/icons-material/Store";
import MessageIcon from "@mui/icons-material/Message";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EditIcon from "@mui/icons-material/Edit";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import SuiInput from "components/SuiInput";
import SuiSelect from "components/SuiSelect";
import Avatar from "@mui/material/Avatar";
import Pagination from "@mui/material/Pagination";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

import api from "services/api";
import storeApi from "services/store-api";

import qs from "query-string";
import toast from "react-hot-toast";

import ReadMore from "components/UpStyled/ReadMore";

import DraggableDialog from "components/UpStyled/DraggableDialog";
import ChatRoom from "pages/messages/chatroom";
import SortableList, { SortableItem } from "react-easy-sort";
import ProductCard from "pages/de/portfolio/components/ProductCard";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import { addProtocol, formatAddress } from "utils/helper";
import Tooltip from "@mui/material/Tooltip";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import { MANUFACTURER_SERVICES, accountTypeOptions } from "utils/data";
import FeaturedStyleList from "./components/FeaturedStyleList";
import FeaturedMoodboardList from "./components/FeaturedMoodboardList";
import FeaturedPostList from "./components/FeaturedPostList";
import FeaturedGalleryList from "./components/FeaturedGalleryList";
import ServiceCard from "./components/ServiceCard";

import AddProductCard from "pages/de/portfolio/components/AddProductCard";
import UploadGalleryModal from "pages/de/portfolio/components/UploadGalleryModal";

import { Empty } from "antd";
import ImgCrop from "antd-img-crop";
import { Upload } from "antd";
import moment from "moment";
import FollowButton2 from "pages/de/posts/components/FollowButton2";
import ImportMoodboardPicture from "pages/de/posts/components/ImportMoodboardPicture";
import PostDetailModal from "pages/de/posts/detail";
import { getBase64, dataURLtoFile, beforeUpload } from "utils/imageHelper";
import ProfileCard from "pages/de/new-portfolio/components/ProfileCard";
import ProfileCardMobile from "pages/de/new-portfolio/components/ProfileCardMobile";

const designerTabs = [
  { label: "posts", key: "post" },
  { label: "featured work", key: "style" },
  { label: "moodboards", key: "moodboard" },
  { label: "gallery", key: "gallery" },
];

const manufacturerTabs = [
  { label: "services", key: "service" },
  { label: "gallery", key: "gallery" },
  { label: "featured work", key: "style" },
  { label: "posts", key: "post" },
  { label: "moodboards", key: "moodboard" },
];

const NewPortfolioPage = ({ editable = true, isPublic = false }) => {
  const [userData, setUserData] = useState({});
  const [workTab, setWorkTab] = useState("post");

  const [postList, setPostList] = useState({ published: [], draft: [] });

  const [counts, setCounts] = useState({});
  const [importMoodboardVisible, setImportMoodboardVisible] = useState(false);
  const [uploadGalleryVisible, setUploadGalleryVisible] = useState(false);

  const { store, updateStore } = useContext(StoreContext);
  const account = useContext(AccountContext);

  const params = useParams();
  const handle = params?.handle;

  useEffect(() => {
    handleRefresh(handle);

    if (!handle) {
      if (account.id) {
        retrievePosts(account.id);
        loadFollowData(account.id);
      }
    } else {
      retrievePosts(handle);
      loadFollowData(handle);
    }
  }, [account.id, handle]);

  useEffect(() => {
    if (userData.account_type == "de") {
      setWorkTab("post");
    } else if (userData.account_type == "ma") {
      setWorkTab("service");
    }
  }, [userData.account_type]);

  let portfolioData = account?.metadata?.portfolio_content || {};
  let storeData = store;
  if (handle) {
    portfolioData = userData?.metadata?.portfolio_content || {};
    storeData = userData?.stores?.[0] || {};
  }

  const backgroundImageUrl = storeData?.metadata?.background_image || "";
  let moodboardList = portfolioData["moodboard_0"] || [];

  const handleRefresh = async (handle) => {
    if (handle) {
      if (isPublic) {
        const userProfile = await storeApi.users.retrieve(handle);
        setUserData(userProfile?.data?.user);
      } else {
        const userProfile = await api.users.retrieve(handle);

        setUserData(userProfile?.data?.user);
      }
    } else {
      try {
        const mySelf = await account.handleRefresh();
        setUserData(mySelf?.user || {});
      } catch (err) {
        console.log(err);
      }
    }
  };

  const retrievePosts = async (userId) => {
    try {
      let allPosts = [];
      if (isPublic) {
        const { data } = await storeApi.post.list({
          owner_id: [userId],
          status: "published",
          order: "-created_at",
        });
        allPosts = data?.posts || [];
      } else {
        const { data } = await api.post.list({
          owner_id: [userId],
          order: "-created_at",
        });
        allPosts = data?.posts || [];
      }

      const publishedList = allPosts.filter((x) => x.status == "published");
      const draftList = allPosts.filter((x) => x.status == "draft");

      setPostList({ published: publishedList, draft: draftList });
    } catch (err) {
      console.log(err);
    }
  };

  const accountType = account?.metadata?.account_role || account.account_role;
  const accountRole = accountTypeOptions.find((x) => x.value == accountType);

  const renderContent = (tab) => {
    if (tab == "style") {
      return (
        <FeaturedStyleList
          userData={userData}
          handle={handle}
          handleRefresh={() => handleRefresh(userData.id)}
          // onSortEnd={onSortEnd}
        />
      );
    } else if (tab == "moodboard") {
      return (
        <FeaturedMoodboardList
          userData={userData}
          handle={handle}
          handleRefresh={() => handleRefresh(userData.id)}
          // onSortEnd={onSortEnd}
        />
      );
    } else if (tab == "post") {
      return (
        <FeaturedPostList
          userData={userData}
          handle={handle}
          handleRefresh={() => retrievePosts(handle)}
          postList={postList}
          setPostList={setPostList}
          isOwner={isOwner}
        />
      );
    } else if (tab == "gallery") {
      return (
        <FeaturedGalleryList
          userData={userData}
          handle={handle}
          handleRefresh={() => handleRefresh(userData.id)}
        />
      );
    } else if (tab == "service") {
      return <ServiceCard />;
    }
  };

  const renderActionButton = (tab) => {
    if (tab == "style") {
      return (
        <AddProductCard
          slot="style_0"
          handleRefresh={handleRefresh}
          content="Add Style"
          type="button"
          size="small"
          sx={{ px: 1 }}
        />
      );
    } else if (tab == "moodboard") {
      return (
        <SuiButton
          color="dark"
          variant="gradient"
          size="small"
          sx={{ px: 1 }}
          onClick={() => setImportMoodboardVisible(true)}
        >
          Add Moodboard
        </SuiButton>
      );
    } else if (tab == "post") {
      return (
        <SuiButton
          variant={"gradient"}
          size="small"
          color="dark"
          component={Link}
          to="/post/create"
        >
          Create
        </SuiButton>
      );
    } else if (tab == "gallery") {
      return (
        <SuiButton
          color="dark"
          variant="gradient"
          size="small"
          sx={{ px: 1 }}
          onClick={() => setUploadGalleryVisible(true)}
        >
          Add Media
        </SuiButton>
      );
    } else if (tab == "service") {
      return (
        <SuiButton
          variant={"gradient"}
          size="small"
          color="dark"
          component={Link}
          to="/edit-profile"
        >
          Edit
        </SuiButton>
      );
    }
  };

  const loadFollowData = async (id) => {
    if (isPublic) {
      const { data } = await storeApi.social.getcount({ id });
      setCounts(data);
    } else {
      const { data } = await api.social.getcount({ id });
      setCounts(data);
    }
  };

  const handleAddMoodboard = async (selectedMoodboards, slot = "moodboard_0") => {
    const moodboard = selectedMoodboards.length > 0 ? selectedMoodboards[0] : selectedMoodboards;

    if (account.id) {
      let old_portfolio = account?.metadata?.portfolio_content || {};
      if (!old_portfolio[slot]) {
        old_portfolio[slot] = [];
      }
      //add new item
      old_portfolio[slot].push({
        img: moodboard.img,
        id: moodboard.id,
        type: "moodboard",
        title: moodboard.name,
      });

      let payload = {
        metadata: {
          ...account?.metadata,
          portfolio_content: old_portfolio,
        },
      };

      try {
        const { data } = await api.account.update(account.id, payload);
        handleRefresh(account.id);
        setImportMoodboardVisible(false);
        toast.success(`Add moodboard to portfolio successfully!`);
      } catch (err) {
        console.log(err);
        toast.error(`Add moodboard to portfolio failed!`);
      }
    } else {
      toast.error("Can't find the user!");
    }
  };

  const handleCropBackgroundImgOk = async (file) => {
    try {
      console.log(file);

      const uploadedImg = await api.uploads.create([file]).then(({ data }) => {
        const uploaded = data.uploads.map(({ url }) => url);
        return uploaded;
      });
      const bgUrl = uploadedImg && uploadedImg.length > 0 ? uploadedImg[0] : "";
      await updateStore({ metadata: { background_image: bgUrl } });
    } catch (err) {
      console.log(err);
    }
  };

  const handleUploadImages = (data) => {
    console.log(data);
    return getBase64(data.file);
    // return api.uploads.create([file])
  };

  const isOwner = account?.id && account.id == userData?.id;

  return (
    <SuiBox>
      <SuiBox>
        <SuiBox className="hover-parent" sx={{ position: "relative" }}>
          <SuiBox
            display="flex"
            alignItems="center"
            position="relative"
            minHeight={"16.75rem"}
            width="100%"
            borderRadius="0"
            sx={{
              backgroundImage: backgroundImageUrl
                ? ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
                    `url(${backgroundImageUrl})`
                : ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
                    `${linearGradient("#ddf1f3", rgba(gradients.secondary.state, 0.4), 0)}`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              //backgroundPosition: "50%",
              backgroundPosition: "top",
              overflow: "hidden",
            }}
          />
          {isOwner ? (
            <SuiBox className="hover-children" sx={{ position: "absolute", top: 10, right: 10 }}>
              <ImgCrop rotate shape="rect" aspect={3} onModalOk={handleCropBackgroundImgOk}>
                <Upload
                  name="avatar"
                  showUploadList={false}
                  customRequest={handleUploadImages}
                  beforeUpload={beforeUpload}
                >
                  <SuiButton
                    color="dark"
                    sx={{
                      padding: "0px 8px",
                      fontSize: 12,
                      lineHeight: 0,
                      minHeight: 25,
                      minWidth: 25,
                      textTransform: "none",
                      borderRadius: "4px",
                    }}
                    size="small"
                    // onClick={handleClickBackgroundImage}
                  >
                    <EditIcon />
                    Edit
                  </SuiButton>
                </Upload>
              </ImgCrop>
            </SuiBox>
          ) : null}
        </SuiBox>
        <SuiBox
          sx={{
            display: {
              xs: "block",
              sm: "block",
              md: "block",
              lg: "none",
              xl: "none",
            },
          }}
        >
          <ProfileCardMobile
            storeData={storeData}
            userData={userData}
            postList={postList.published}
            counts={counts}
          />
        </SuiBox>
      </SuiBox>
      <SuiBox display="flex" gap={1} mt={-20}>
        <SuiBox
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "none",
              lg: "block",
              xl: "block",
            },
            minWidth: 280,
            width: 280,
          }}
        >
          <ProfileCard
            storeData={storeData}
            userData={userData}
            postList={postList.published}
            counts={counts}
          />
        </SuiBox>
        <SuiBox mt={22} px={2} sx={{ flexGrow: 1, mx: 1 }}>
          <SuiBox sx={{ maxWidth: 1200, mx: "auto" }}>
            <SuiBox display="flex" justifyContent="space-between">
              <SuiBox display="flex" gap={1} sx={{ flexWrap: "wrap", mb: 1 }}>
                {userData.account_type == "de"
                  ? designerTabs.map((dt) => (
                      <SuiButton
                        variant={workTab == dt.key ? "contained" : "text"}
                        circular
                        size="small"
                        onClick={() => setWorkTab(dt.key)}
                        color="dark"
                        sx={{ px: 1, textTransform: "capitalize" }}
                      >
                        {dt.label}
                      </SuiButton>
                    ))
                  : manufacturerTabs.map((mt) => (
                      <SuiButton
                        variant={workTab == mt.key ? "contained" : "text"}
                        circular
                        size="small"
                        onClick={() => setWorkTab(mt.key)}
                        color="dark"
                        sx={{ px: 1, textTransform: "capitalize" }}
                      >
                        {mt.label}
                      </SuiButton>
                    ))}
              </SuiBox>
              {isOwner ? <SuiBox>{renderActionButton(workTab)}</SuiBox> : null}
            </SuiBox>

            <SuiBox sx={{ width: "100%" }}>{renderContent(workTab)}</SuiBox>
          </SuiBox>
        </SuiBox>
      </SuiBox>

      {importMoodboardVisible ? (
        <ImportMoodboardPicture
          handleClose={() => setImportMoodboardVisible(false)}
          visible={importMoodboardVisible}
          handleOk={handleAddMoodboard}
          selectedMoodboards={moodboardList}
          isMulti={false}
        />
      ) : null}
      {uploadGalleryVisible ? (
        <UploadGalleryModal
          handleClose={() => setUploadGalleryVisible(false)}
          visible={uploadGalleryVisible}
          handleRefresh={() => {
            handleRefresh();
          }}
        />
      ) : null}
    </SuiBox>
  );
};

export default NewPortfolioPage;
